import React, { Component } from 'react'
import { Step } from 'semantic-ui-react'
import dateFormat from 'dateformat'
import { observer } from 'mobx-react'
import DeviceInfo from '../Admin/User/Edit/Device/DeviceInfo'

/**
 * Displays information about current subscription.
 */

export default
@observer
class InfoComponent extends Component {
  render() {
    const { device } = this.props

    let endDate = null

    if (device) {
      const deviceInfo = new DeviceInfo(device.activationCode, device.id)
      endDate = deviceInfo.until_activated
    }

    let subscription = {
      status: {
        text: 'Inactive',
        icon: 'ban',
      },
      period: {
        text: 'Not available',
        icon: 'delete calendar',
      },
    }

    if (endDate !== null) {
      const periodText = dateFormat(endDate, 'dd mmmm yyyy')

      subscription = {
        status: {
          text: 'License Status',
          icon: 'checkmark',
        },
        period: {
          text: periodText,
          icon: 'checked calendar',
        },
      }
    }

    let boxes = [
      <Step
        key="status"
        style={{ textTransform: 'capitalize' }}
        icon={subscription.status.icon}
        title={subscription.status.text}
        description={
          endDate !== null
            ? 'License is Active'
            : 'No License Found or License Expired'
        }
      />,
    ]

    if (endDate !== null) {
      boxes.push(
        <Step
          key="period"
          style={{ textTransform: 'capitalize' }}
          icon={subscription.period.icon}
          title={'License Expiration'}
          description={subscription.period.text}
        />
      )
    }

    return (
      <div>
        <Step.Group fluid vertical>
          {boxes}
        </Step.Group>
      </div>
    )
  }
}
